import {baseRequestService} from "../base.ts";
import {TelegramLink} from "../../types/domain.ts";

export const authTelegramGet = () => baseRequestService<TelegramLink>({
    url: '/auth/telegram',
    method: 'GET',
})